// extracted by mini-css-extract-plugin
module.exports = {"item":"RadioboxItem__item--Vx7KJ"};